import { MARKETPLACE_ID } from '@amzn/sss-website-theme';

// Marketplaces that use MM/DD/YYYY format — all others default to DD/MM/YYYY
const MM_DD_YYYY_MARKETPLACES: string[] = [MARKETPLACE_ID.NA];

/** Determines the date display format based on marketplace. */
export const getDateFormat = (marketplaceId: string | undefined): 'MM/DD/YYYY' | 'DD/MM/YYYY' =>
  marketplaceId && MM_DD_YYYY_MARKETPLACES.includes(marketplaceId) ? 'MM/DD/YYYY' : 'DD/MM/YYYY';

/** Formats a raw input value as the user types (auto-inserts slashes). */
export const applyDateMask = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

/**
 * Parses a formatted date string (MM/DD/YYYY or DD/MM/YYYY) into a Date at UTC midnight.
 * Returns null if the string doesn't match the expected format or represents an invalid date.
 */
export const parseDateInput = (value: string, format: 'MM/DD/YYYY' | 'DD/MM/YYYY'): Date | null => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
  if (!match) return null;

  const part1 = Number(match[1]);
  const part2 = Number(match[2]);
  const year = Number(match[3]);

  const month = format === 'MM/DD/YYYY' ? part1 : part2;
  const day = format === 'MM/DD/YYYY' ? part2 : part1;

  if (month < 1 || month > 12 || day < 1 || day > 31) return null;

  // Date.UTC uses 0-based months (0 = January, 11 = December)
  const date = new Date(Date.UTC(year, month - 1, day));
  // Verify the constructed date matches input (catches invalid dates like Feb 30,
  // where Date rolls over to Mar 2 — the UTC month/day would no longer match)
  if (date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;

  return date;
};
